import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import Clients from './pages/Clients';
import Inbox from './pages/Inbox';
import Signups from './pages/Signups';
import { AdminDashboard, AdminIncidents } from './pages/Dashboard';
import ThreatActors from './pages/ThreatActors';
import './index.css';

const NAV = [
  { label: 'Overview', path: '/overview' },
  { label: 'Signups', path: '/signups' },
  { label: 'Inbox', path: '/inbox' },
  { label: 'Clients', path: '/clients' },
  { label: 'Incidents', path: '/incidents' },
  { label: 'Threats', path: '/threats' },
];

const s = {
  wrap: { display: 'flex', flexDirection: 'column', height: '100vh' },
  top: { height: 50, background: 'var(--surface)', borderBottom: '0.5px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', flexShrink: 0 },
  logo: { display: 'flex', alignItems: 'center', gap: 9, fontSize: 13, fontWeight: 500, letterSpacing: '0.1em', color: 'var(--gold)' },
  icon: { width: 24, height: 24, background: 'var(--gold)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  badge: { fontSize: 9, background: 'var(--gold-dim)', color: 'var(--gold)', padding: '2px 6px', borderRadius: 6, letterSpacing: '0.1em', marginLeft: 4 },
  nav: { display: 'flex', gap: 2 },
  navLink: { fontSize: 12, padding: '5px 12px', borderRadius: 6, color: 'var(--text2)', textDecoration: 'none', transition: 'all 0.1s' },
  navActive: { color: 'var(--gold)', background: 'var(--gold-dim)' },
  logout: { fontSize: 11, color: 'var(--text2)', background: 'none', border: 'none', cursor: 'pointer' },
  body: { flex: 1, overflow: 'hidden', display: 'flex' },
  main: { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' },
};

export default function App() {
  const [adminKey, setAdminKey] = useState(() => localStorage.getItem('shaheen_admin_username') || '');

  useEffect(() => {
    if (adminKey) {
      window.__ADMIN_KEY = adminKey;
    }
  }, [adminKey]);

  const handleLogin = (key) => { setAdminKey(key); };
  const handleLogout = () => {
    const token = localStorage.getItem('shaheen_admin_token');
    if (token) {
      const base = process.env.REACT_APP_API_URL || 'https://web-production-120c.up.railway.app';
      fetch(`${base}/admin/logout`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } }).catch(() => {});
    }
    localStorage.removeItem('shaheen_admin_key');
    localStorage.removeItem('shaheen_admin_username');
    localStorage.removeItem('shaheen_admin_token');
    setAdminKey('');
  };

  if (!adminKey) return <AdminLogin onLogin={handleLogin} />;

  return (
    <BrowserRouter>
      <div style={s.wrap}>
        <div style={s.top}>
          <div style={s.logo}>
            <div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.2" stroke="#c8b48a" strokeWidth="1.5" strokeLinejoin="round"/><path d="M8.5 12.5L11 15L15.5 9.5" stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
            SHAHEEN <span style={s.badge}>ADMIN</span>
          </div>
          <div style={s.nav}>
            {NAV.map(n => (
              <NavLink key={n.path} to={n.path} style={({ isActive }) => ({ ...s.navLink, ...(isActive ? s.navActive : {}) })}>{n.label}</NavLink>
            ))}
          </div>
          <button style={s.logout} onClick={handleLogout}>Sign out</button>
        </div>
        <div style={s.body}>
          <main style={s.main}>
            <Routes>
              <Route path="/overview"  element={<AdminDashboard />} />
              <Route path="/clients"   element={<Clients />} />
              <Route path="/incidents" element={<AdminIncidents />} />
              <Route path="/inbox"     element={<Inbox />} />
              <Route path="/signups"   element={<Signups />} />
              <Route path="/threats"   element={<ThreatActors />} />
              <Route path="*"          element={<Navigate to="/clients" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
}
